import QueryUtils from '@/utils/query';
import appmixer from '@/plugins/appmixer';

export default {
    async queryAuditLogs(query = {}) {
        query = QueryUtils.processQuery(query);
        const apiResult = await appmixer.api.getAuditLogs(query);
        return { data: apiResult.data, contentRange: apiResult.contentRange };
    },

    async queryAuditLogsCSV(query = {}) {
        query.format = 'csv';
        query = QueryUtils.processQuery(query);
        return appmixer.api.getAuditLogs(query);
    }
};
